import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/common/api-service/api.service';
import { Router } from '@angular/router';
import $ from "jquery";
import { Subscription, Observer, Observable } from 'rxjs';
import { SEOService } from 'src/app/common/api-service/seo.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription: Subscription[] = [];

  public topMenus: any[] = [];
  public mainMenus: any[] = [];
  public banners: any[] = [];
  public notifications: any[] = [];
  public events: any[] = [];
  public associations: any[] = [];
  isChangeRoute: boolean = true;
  public titleSearch: string = '';
  isLogin: boolean = false;
  isLogOut: boolean = false;
  footerIMG: string;
  getSysMemberValue: any;
  sysmemberSubject: any;

  titleSeo = {
    id: '',
    siteid: '',
    title: '',
    keywords: '',
    description: '',
    about: '',
    address1: '',
    address2: '',
    phone: '',
    email: '',
    fanpage: '',
    facebook: '',
    gmail: '',
    twitter: '',
    youtube: '',
    approved: '',
    lang: '',
  }
  getUrl: string = '';
  language: string;
  // observable
  observable: Observable<any>;
  observer: Observer<any>;
  /**
   * constructor
   * @param api
   */
  constructor(public api: ApiService, private router: Router, public seoService: SEOService) {
    this.getUrl = localStorage.getItem('lastUrl');
    // xử lý bất đồng bộ
    this.observable = Observable.create((observer: any) => {
      this.observer = observer;
    });
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    // load language
    this.language = this.api.getLanguage();

    // first load
    this.subscription.push(
      this.api.sendDataService.language$.subscribe((data) => {
        // load data menu
        if (this.mainMenus.length <= 0) {
          this.loadDataMenu();
        }
        this.getFooterWithSite();
        this.getSysMemberValue = localStorage.getItem('sysmemberSubject');

        // redirect to last page
        if (this.getSysMemberValue == '' || this.getSysMemberValue == undefined) {
          this.isLogOut = false;
        } else {
          this.isLogOut = true;
        }

      })
    );

    // animation for change page
    this.animationChangePage();

    this.hideOrHiddenButtonToTop();
    this.getTitleSite();
  }

  /**
     * ngAfterViewInit
     */
  ngAfterViewInit() {
    // process click of menu response
    this.subscription.push(this.observable.subscribe(data => {
      if (data) {

        $(document).ready(function () {
          // remove event first
          $(".icon-menu-responsive").unbind('click');

          $(".icon-menu-responsive").click(function () {
            $(".respon-menu").slideToggle();
            return false;
          });

          // remove event first
          $(".menu-slide").unbind('click');

          $(".menu-slide").click(function () {
            // $(".respon-menu>li>ul").slideUp();
            var target = $(this)
              .parent()
              .children(".slideContent");

            $(target).slideToggle();
            return false;
          });
        });
      }
    }));
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.subscription.forEach((item) => {
      item.unsubscribe();
    });
  }

  /**
     * getFooterWithSite
     */
  getTitleSite() {
    // update view of news
    const param = {
      'siteid': 11,
      'lang': this.api.getLanguage()
    };

    this.subscription.push(this.api.excuteAllByWhat(param, '27').subscribe(result => {
      let data = result.data;
      if (result.status == true) {

        this.titleSeo = data[0];
        this.seoService.setTitle(this.titleSeo.title);
      } else {
        this.titleSeo = null;
      }
    }));
  }

  /**
   * loadDataMenu
   */
  loadDataMenu() {
    // init array
    this.topMenus = [];
    this.mainMenus = [];



    // load data main menu
    const param2 = {
      'siteid': 11,
      'position': 2,
      'lang': this.api.getLanguage(),
    };
    this.subscription.push(
      this.api.excuteAllByWhat(param2, '11').subscribe((result) => {
        let data = result.data;
        if (result.status == true && data.length > 0) {
          this.mainMenus = data;

          // load child main data
          this.subscription.push(
            this.api.excuteAllByWhat(param2, '12').subscribe((result1) => {
              let data1 = result1.data
              if (result1.status == true && data1.length > 0) {
                // add child menu to mainMenus
                this.mainMenus.forEach(item => {
                  item.childs = [];
                  data1.forEach(ele => {
                    if (item.id == ele.ptypeid) {
                      item.childs.push(ele);
                    }
                  });
                });

                // data is loading finish
                this.observer.next(true);
              }
            })
          );
        } else {
          this.mainMenus = [];
        }
      })
    );
  }


  /**
     * on Menu Item Click
     * @param item
     */
  onMenuItemClick(item) {
    const title = this.api.cleanAccents(item.title).split(' ').join('-');
    switch (item.keyword) {
      case 'home':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to home
        this.router.navigate(['/']);
        break;

      case 'feedback':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to feedback
        this.router.navigate(['/feedback'], { skipLocationChange: false });
        break;

      case 'search':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to search
        this.router.navigate(['/search'], { skipLocationChange: false });
        break;

      case 'gallery':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to gallery
        this.router.navigate(['/album'], { skipLocationChange: false });
        break;

      case 'login':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to login
        this.router.navigate(['/login'], { skipLocationChange: false });
        break;

      case 'sitemap':
        // slideUpMenuOnMobile
        this.api.slideUpMenuOnMobile();

        // go to sitemap
        this.router.navigate(['/sitemap'], { skipLocationChange: false });
        break;

      case 'contents':
        // go to contents
        // check is parent or child
        if (item.ptypeid == 0) {
          this.router.navigate(['/list/' + item.keyword + '/' + title + '/' + item.id], { skipLocationChange: false });
        } else {
          // slideUpMenuOnMobile
          this.api.slideUpMenuOnMobile();

          this.router.navigate(['/list/' + item.keyword + 'child/' + title + '/' + item.id], { skipLocationChange: false });
        }
        break;

      case 'documents':
        // go to news
        // check is parent or child
        if (item.ptypeid == 0) {
          this.router.navigate(['/list/' + item.keyword + '/' + title + '/' + item.id], { skipLocationChange: false });
        } else {
          // slideUpMenuOnMobile
          this.api.slideUpMenuOnMobile();

          this.router.navigate(['/list/' + item.keyword + 'child/' + title + '/' + item.id], { skipLocationChange: false });
        }
        break;

      case 'news':
        // go to news
        if (item.ptypeid == 0) {
          this.router.navigate(['/list/' + item.keyword + '/' + title + '/' + item.id], { skipLocationChange: false });
        } else {
          // slideUpMenuOnMobile
          this.api.slideUpMenuOnMobile();

          this.router.navigate(['/list/' + item.keyword + 'child/' + title + '/' + item.id], { skipLocationChange: false });
        }
        break;

      case 'noticeboard':
        // go to news
        // check is parent or child
        if (item.ptypeid == 0) {
          this.router.navigate(['/list/' + item.keyword + '/' + title + '/' + item.id], { skipLocationChange: false });
        } else {
          // slideUpMenuOnMobile
          this.api.slideUpMenuOnMobile();

          this.router.navigate(['/list/' + item.keyword + 'child/' + title + '/' + item.id], { skipLocationChange: false });
        }
        break;
    }

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }

  /**
    * on news Click
    * @param url
    */
  onTitleClick(news) {
    let formatTitle = this.api.cleanAccents(news.title).split(' ').join('-');
    let re = /\//gi;
    formatTitle = formatTitle.replace(re, '');
    const url = '/detail/news/' + formatTitle + '/' + news.id + '/' + news.typeid;
    this.router.navigate([url.toLowerCase()], { skipLocationChange: false });

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }

  /**
   * animation Change Page
   */
  animationChangePage() {
    this.api.sendDataService.data$.subscribe((data) => {
      // animation
      setTimeout(() => {
        this.api.scrollToTop();
      }, 100);
    });
  }

  /**
     * on Login Click
     */
  onLoginClick() {
    const url = '/login';
    // this.router.navigate([url.toLowerCase()], { skipLocationChange: false });
    window.location.href = '/login'
  }

  //log out SysMember
  logOutClick() {
    localStorage.removeItem('sysmemberSubject');
    this.sysmemberSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('sysmemberSubject')));
    const url = '';
    this.router.navigate([url.toLowerCase()], { skipLocationChange: false });
    localStorage.removeItem('lastUrl');
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  /**
   * on vietnamese Click
   */
  onVnClick() {
    this.api.language = 'vn';
    this.api.cookie.setCookie('language', 'vn');
    this.language = this.api.getLanguage();

    // notification change language
    this.api.sendDataService.setDataLanguage('vn');
    this.router.navigate(['']);
    setTimeout(() => {
      window.location.reload();
    }, 200)
  }

  /**
   * on English Click
   */
  onEnClick() {
    this.api.language = 'en';
    this.api.cookie.setCookie('language', 'en');
    this.language = this.api.getLanguage();

    // notification change language
    this.api.sendDataService.setDataLanguage('en');
    this.router.navigate(['']);
    setTimeout(() => {
      window.location.reload();
    }, 200)
  }

  /**
   * on France Click
   */
  onFrClick() {
    this.api.language = 'fr';
    this.api.cookie.setCookie('language', 'fr');
    this.language = this.api.getLanguage();

    // notification change language
    this.api.sendDataService.setDataLanguage('fr');
    this.router.navigate(['']);
    setTimeout(() => {
      window.location.reload();
    }, 200)
  }

  /**
   * hide Or Hidden Button To Top
   */
  hideOrHiddenButtonToTop() {
    //Get the button
    var mybutton = document.getElementById("myBtn");

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () { scrollFunction() };

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  }

  onToTopClick() {
    this.api.scrollToTop();
  }

  /**
* onSearchClick
* @param title
*/
  onSearchClick(titleSearch) {
    const url = '/search' + '/' + titleSearch;
    this.router.navigate([url]);
  }

  /**
   * getFooterWithSite
   */
  getFooterWithSite() {
    // update view of news
    const param = {
      'siteid': 11,
      'lang': this.api.getLanguage()
    };

    this.subscription.push(this.api.excuteAllByWhat(param, '27').subscribe(result => {
      let data = result.data;
      if (result.status == true) {

        if (data[0].banner.substr(0, 9) == '/uploads/') {
          data[0].banner = 'https://hce.edu.vn' + data[0].banner;
        } else {
          data[0].banner = data[0].banner;
        }

        this.footerIMG = 'background-image: url(' + data[0].banner + ')';

      } else {
        this.footerIMG = null;
      }
    }));
  }

  /**
   * onClickLogin
   */
  onClickLogin() {
    // redirect to last page
    // if (this.getUrl == '' || this.getUrl == undefined) {
    //   this.router.navigate(["/login"]);
    // } else {
    //   this.router.navigate([this.getUrl]);
    // }
    this.router.navigate(["/login"]);
  }

  onClickAccount() {
    this.router.navigate([this.getUrl]);
  }
}
